import { useEffect } from 'react';

import fromAnyToString from 'utils/converters/fromAnyToString';
import { isEnvDev, isEnvLab, isEnvQA, isEnvStage } from 'utils/env/determine.util';
import logger from 'utils/logger.util';

const IS_STAGE = isEnvStage();
const IS_QA = isEnvQA();
const IS_DEV = isEnvDev();
const IS_LAB = isEnvLab();

const L = logger('useTitle');

export const useTitle = () => {
  useEffect(() => {
    if (!IS_STAGE && !IS_DEV && !IS_QA && !IS_LAB) return;

    const listener = () => {
      document.title = `SLICK (${fromAnyToString(window.location.hash)}) (DEVELOPMENT)`;
    };

    listener();

    try {
      window.navigation.addEventListener('navigatesuccess', listener);
    } catch (e) {
      L.debug('useTitleUpdate()', 'error:', fromAnyToString(e));
    }

    return () => {
      try {
        window.navigation.removeEventListener(listener);
      } catch (e) {
        L.debug('useTitleUpdate()', 'error:', fromAnyToString(e));
      }
    };
  }, []);
};
